import createTheme from "@mui/material/styles/createTheme";
import SelectDropdownIcon from "../components/icons/SelectDropdownIcon";

export const customTheme = createTheme({
  palette: {
    primary: {
      main: "rgba(13, 109, 238, 1)",
      dark: "rgba(0, 55, 164, 1)"
    },
    secondary: {
      main: "rgba(101, 91, 80, 1)",
    },
    text: {
      secondary: "rgba(175, 166, 139, 1)",
    }
  },
  typography: {
    fontFamily: "'Sohne', sans-serif",
    button: {
      textTransform: "none",
      fontWeight: 500,
      fontSize: "16px",
    },
    body1: {
      color: "#655B50",
      fontWeight: 400,
    },
    body2: {
      color: "#655B50",
      fontWeight: 400,
    },
    h4: {
      color: "#655B50",
      fontWeight: 600,
    },
  },
  components: {
    MuiSelect: {
      defaultProps: {
        IconComponent: SelectDropdownIcon,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "100px",
          background: "rgba(255, 254, 250, 1)",
          "&:hover": {
            background: "rgba(255, 255, 255, 1)",
          },
          "&.Mui-focused": {
            background: "rgba(255, 255, 255, 1)",
          },
        },
        notchedOutline: {
          borderRadius: "100px",
          borderColor: "rgba(214, 207, 196, 1)",
          borderWidth: "1px",
          transition: "border-color 0.3s ease",
        },
        input: {
          padding: '12px 24px',
          fontWeight: 400,
          fontSize: "16px",
          color: "#655B50",

          "&::placeholder": {
            color: "#AFA68B",
            opacity: 1,
            fontWeight: 400,
          },
        },
        inputMultiline: {
          fontWeight: 400,
          fontSize: "16px",
          color: "#655B50",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        // "@font-face": [
        //   {
        //     fontFamily: "Sohne",
        //     src: `url("/fonts/sohne/otf/Sohne-Extralight.otf")`,
        //     fontWeight: 200,
        //     fontStyle: "normal",
        //     fontDisplay: "swap",
        //   },
        //   {
        //     fontFamily: "Sohne",
        //     src: `url("/fonts/sohne/otf/Sohne-Light.otf")`,
        //     fontWeight: 300,
        //     fontStyle: "normal",
        //     fontDisplay: "swap",
        //   },
        //   {
        //     fontFamily: "Sohne",
        //     src: `url("/fonts/sohne/otf/Sohne.otf")`,
        //     fontWeight: 400,
        //     fontStyle: "normal",
        //     fontDisplay: "swap",
        //   },
        // ],
        body: {
          backgroundColor: "#FDF9EF",
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-label": {
            color: "#655B50",
            fontWeight: 500,
            fontSize: "14px",
          },
          "& .MuiStepLabel-label.Mui-active": {
            color: "#655B50",
            fontWeight: 500,
            fontSize: "14px",
          }
        }
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        text: {
          fill: "#FFFEFA",
          fontWeight: 700,
          fontSize: "12px",
          dominantBaseline: "middle",
          transform: "translateY(1px)",
        },
        root: {
          color: "#C2BAAE",
          "& .MuiStepIcon-text": {
            fontWeight: 400,
          },
          "&.Mui-active": {
            color: "#655B50",
            "& .MuiStepIcon-text": {
              fontWeight: 600,
            },
          },
        },
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          color: "#C2BAAE",
        },
      }
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          paddingTop: "12px",
          paddingBottom: "12px",
          borderRadius: "100px",
          lineHeight: "1.4",
          boxShadow: 'none',
        },
        contained: {
          paddingTop: "12px",
          paddingBottom: "12px",
          borderRadius: "100px",
          lineHeight: "1.4",
          boxShadow: "none",
          '&:hover': {
            boxShadow: "none",
            // backgroundColor: theme.palette.primary.dark,
          },
        },
        text: {
          padding: 0,
          '&:hover': {
            background: "none"
          }
        }
      },
    },
  }
});

export const HEARD_FROM_OPTIONS = [
  { id: 0, label: "Google" },
  { id: 1, label: "Facebook/Instagram" },
  { id: 2, label: "Tiktok" },
  { id: 3, label: "Reddit" },
  { id: 4, label: "YouTube" },
  { id: 5, label: "TV/Streaming" },
  { id: 6, label: "Amazon" },
  { id: 7, label: "Friends or Family" },
  { id: 8, label: "1000 Hours Outside" },
  { id: 9, label: "Other" },
];

export const BOUGHT_FROM_OPTIONS = [
  { id: 1, label: "Amazon" },
  { id: 2, label: "COSMO Website" },
  { id: 3, label: "Buy with Prime on COSMO Website" },
  { id: 4, label: "Walmart" },
  { id: 5, label: "TikTok Shop" },
  { id: 6, label: "Target" },
  { id: 7, label: "I don't know" },
];